export default __webpack_public_path__ + "static/media/regulatory--buses-only--g1.5305590b.png";